import { useNavigate } from 'react-router';
import { toast } from '@lib/ui';
import type { WizardPersona } from '../types';
import { TemplateWizard } from './index';

export default function TemplateWizardPage() {
  const navigate = useNavigate();

  const handleComplete = (persona: WizardPersona) => {
    toast.success(`Persona "${persona.name}" created successfully!`);
    navigate('/personas');
  };

  const handleCancel = () => {
    navigate('/poc/wizards');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-900">
      <TemplateWizard isOpen={true} onClose={handleCancel} onComplete={handleComplete} />
    </div>
  );
}
